import { render, staticRenderFns } from "./newManagementStandardOfFranchiseeZH.vue?vue&type=template&id=a5746d0a&scoped=true"
import script from "./newManagementStandardOfFranchiseeZH.vue?vue&type=script&lang=js"
export * from "./newManagementStandardOfFranchiseeZH.vue?vue&type=script&lang=js"
import style0 from "./newManagementStandardOfFranchiseeZH.vue?vue&type=style&index=0&id=a5746d0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5746d0a",
  null
  
)

export default component.exports